import type { GetSuggestionsResult, Category, Shop } from "@/shared/apollo-api/__generated__/types";
import { ESearchSuggestionBlockType, type TSearchSuggestions, type TSearchSuggestionBlock } from "../models/TSearchSuggestions";
import { CategoryMM } from "~/entities/category";

export function getSuggestionsMapper(suggestions: GetSuggestionsResult, previousTextItems: string[] = []): TSearchSuggestions {
  const blocks = suggestions.blocks?.filter(Boolean) || [];
  
  return {
    blocks: blocks.map(block => {
      if (!block) {
        return {
          items: [],
          blockType: ESearchSuggestionBlockType.text
        } as TSearchSuggestionBlock;
      }
      
      switch (block.__typename) {
        case 'PopularSuggestionsBlock':
          return {
            items: block.popularSuggestions?.filter(Boolean) || [],
            blockType: ESearchSuggestionBlockType.popular
          } as TSearchSuggestionBlock;
          
        case 'TextSuggestionsBlock':
          return {
            items: block.values?.filter(Boolean).map(value => ({
              title: value,
              isPrevious: previousTextItems.includes(value)
            })) || [],
            blockType: ESearchSuggestionBlockType.text
          } as TSearchSuggestionBlock;
          
        case 'CategorySuggestionsBlock':
          return {
            items: block.categories?.filter(Boolean).map(suggestionCategoryMapper) || [],
            blockType: ESearchSuggestionBlockType.category
          } as TSearchSuggestionBlock;
          
        case 'ShopSuggestionsBlock':
          return {
            items: block.shops?.filter(Boolean).map((shop: Shop) => ({
              avatar: {
                low: shop.avatar?.low || ''
              },
              id: shop.id,
              title: shop.title,
              url: shop.url
            })) || [],
            blockType: ESearchSuggestionBlockType.shop
          } as TSearchSuggestionBlock;
          
        default:
          return {
            items: [],
            blockType: ESearchSuggestionBlockType.text
          } as TSearchSuggestionBlock;
      }
    }).filter(block => block.items.length > 0)
  };
}

function suggestionCategoryMapper(category: Category): CategoryMM {
  return new CategoryMM({
    id: category.id,
    title: category.title,
    icon: {
      link: category.icon || undefined,
      svg: undefined
    },
    parent: category.parent ? suggestionCategoryMapper(category.parent) : undefined
  });
}